export const environment = {
    production: false,
    api: 'https://4mb5bchmtd.execute-api.eu-west-3.amazonaws.com/prod/',
    api_key: 'GJQtE1Ybkw1YBzGdHxbiZ7N9dwj5NBEWaH60C9Hb',
    api_2: 'https://qx1xy30b1f.execute-api.eu-west-3.amazonaws.com/prod/',
    api_key_2: 'lngr4600UL2DcYLUrQsqs6fDrp80ldgmaa9VHdfT',
    iframe_url: 'https://chatbot-dev.nubios.be/chatbot?clientId=CLIENT_ID',
};
